import React from 'react';
import ModalComponent from '../../../../../../components/modal/index';
import FieldComponent from '../../../../../../components/field/index';
import PhoneNumber from 'awesome-phonenumber';
import validator from 'email-validator';
import doctors from '../../../../../../services/doctors/index';

export default class EditDoctorComponent extends React.Component {
    state = {}

    static getDerivedStateFromProps(nextProps, prevState) {
        let errors = {
            name: "",
            lastname: "",
            phone: "",
            email: ""
        }
        if(nextProps.doctor){
            let fields = Object.assign({}, nextProps.doctor)
            return {fields: fields, errors: errors}
        } else
            return {fields: errors, errors: errors}
    }

    onInputChange = (e) => {
        let {name, value} = e.target;
        let newFields = Object.assign({}, this.state.fields);
        let newErrors = Object.assign({}, this.state.errors)
        newFields[name] = value;
        newErrors[name] = "";
        this.setState({fields: newFields, errors: newErrors})
    }

    hasError = () => {
        let errors = Object.assign({},this.state.errors);
        let hasError = false
        if(!this.state.fields.name){
            errors.name = "El campo nombre es obligatorio";
            hasError = true;
        }

        if(!this.state.fields.lastname) {
            errors.lastname = "El campo apellidos es obligatorio";
            hasError = true;
        }

        const number = new PhoneNumber(this.state.fields.phone, "MX")

        if(this.state.fields.phone && !number.isValid()) {
            errors.phone = "Porfavor introduzca un número de teléfono válido";
            hasError = true;
        }

        if(this.state.fields.email && !validator.validate(this.state.fields.email)) {
            errors.email = "Porfavor introduzca un correo válido";
            hasError = true;
        }

        this.setState({errors: errors})
        return hasError
    }

    submit = (e) => {
        e.preventDefault();

        if(!this.hasError()){
            if(!this.props.doctor){
                doctors.insert({
                    ...this.state.fields,
                    status: "activo"
                }, (err, doctor) => {
                    this.props.addDoctor(doctor)
                })
            } else {
                doctors.update({_id: this.props.doctor._id}, {...this.state.fields},(err, status) => {
                    this.props.replaceDoctor({...this.state.fields})
                })
            }
        }
    }

    render() {
        return (
            <ModalComponent {...this.props} hasClose={true}>
                <div className="modal-card">
                    <header className="modal-card-head">
                    <p className="modal-card-title">
                        {this.props.doctor ? "Editar doctor" : "Crear doctor"}
                    </p>
                    </header>
                    <section className="modal-card-body">
                        <form id="form" onSubmit={this.submit}>
                            <div className="field-body">
                                <FieldComponent onInputChange={this.onInputChange} label="Nombre *"
                                    name="name" icon="user-md"
                                    value={this.state.fields.name} error={this.state.errors.name}
                                    />
                                <FieldComponent onInputChange={this.onInputChange} label="Apellidos *"
                                    name="lastname" icon="user"
                                    value={this.state.fields.lastname} error={this.state.errors.lastname}
                                    />
                            </div>
                            <FieldComponent onInputChange={this.onInputChange} label="Teléfono (10 dígitos)"
                                name="phone" icon="phone"
                                value={this.state.fields.phone} error={this.state.errors.phone}
                                />
                            <FieldComponent onInputChange={this.onInputChange} label="Correo"
                                name="email" icon="envelope"
                                value={this.state.fields.email} error={this.state.errors.email}
                                />
                            {this.props.doctor &&
                            <React.Fragment>
                                <label style={{color: "#363636"}}>Estado</label>
                                <div className="select is-fullwidth">
                                    <select defaultValue={this.state.fields.status} name="status" onChange={this.onInputChange}>
                                        <option value="activo">Activo</option>
                                        <option value="inactivo">Inactivo</option>
                                    </select>
                                </div>
                            </React.Fragment>}
                        </form>
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button is-primary" form="form" type="submit">
                            {this.props.doctor ? "Guardar" : "Agregar"}
                        </button>
                    </footer>
                </div>
            </ModalComponent>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/doctors/components/edit-doctor/index.js